import {UPDATE_URL} from './types';


export const redirectUrlAction = (url) => dispatch => {
    dispatch({
        type: UPDATE_URL,
        url: url,
    })

}
